import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

// =====================================================================
// 🪟 AdminSheet — contenedor visual de los modales del panel: hoja desde
// abajo en el celular, tarjeta centrada en tablet/computadora. Solo
// presentación: cada modal sigue manejando su propio estado y acciones.
// =====================================================================

const AdminSheet = ({
  isDarkMode, title, eyebrow, onClose, footer, children,
  maxWidth = 'sm:max-w-lg', zIndex = 999999, label,
}) => (
  <AnimatePresence>
    <div className="fixed inset-0 flex items-end sm:items-center justify-center sm:p-4 bg-black/60" style={{ zIndex }}>
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 40 }}
        transition={{ type: 'spring', bounce: 0, duration: 0.35 }}
        role="dialog" aria-modal="true" aria-label={label || (typeof title === 'string' ? title : undefined)}
        className={`w-full ${maxWidth} flex flex-col max-h-[92dvh] sm:max-h-[88vh] relative overflow-hidden rounded-t-[28px] sm:rounded-[28px] shadow-2xl ${isDarkMode ? 'bg-gray-900 text-gray-50' : 'bg-gray-50 text-gray-900'}`}
      >
        <div className="px-5 sm:px-6 pt-2.5 sm:pt-6 pb-3 shrink-0">
          <span className={`sm:hidden block mx-auto mb-3 w-10 h-1 rounded-full ${isDarkMode ? 'bg-white/20' : 'bg-gray-900/20'}`} />
          <div className="flex justify-between items-start gap-4">
            <div className="min-w-0">
              {eyebrow && <p className={`text-[13px] font-medium mb-1 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>{eyebrow}</p>}
              <h3 className="font-display text-[32px] leading-none">{title}</h3>
            </div>
            {onClose && (
              <button onClick={onClose} aria-label="Cerrar"
                className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 transition-colors ${isDarkMode ? 'bg-white/[0.06] text-gray-400 hover:text-gray-50' : 'bg-gray-900/[0.05] text-gray-600 hover:text-gray-900'}`}>
                <X size={18} />
              </button>
            )}
          </div>
        </div>

        <div className="flex-1 overflow-y-auto overscroll-contain px-5 sm:px-6 pt-2 pb-5 custom-scrollbar">
          {children}
        </div>

        {footer && (
          <div className={`px-5 sm:px-6 pt-3 pb-[calc(env(safe-area-inset-bottom)+16px)] sm:pb-6 border-t flex gap-2.5 shrink-0 ${isDarkMode ? 'border-white/[0.08]' : 'border-gray-900/[0.08]'}`}>
            {footer}
          </div>
        )}
      </motion.div>
    </div>
  </AnimatePresence>
);

export default AdminSheet;
